module.exports = __webpack_public_path__ + "img/reorder_desc.b100bf08.svg";